import { useEffect, useState } from "react";
import { useTranslate } from "@refinedev/core";
import PricingModal from "pages/subscription/components/PricingModal/";
import { UpgradePromptModal } from "@libertify/ui";
import { useQuota } from "hooks/useQuota";
import { QuotaFeatures } from "@/constants";
import { useAnalytics } from "hooks/useAnalytics/";
import { AnalyticsEvents } from "types/analytics/";

interface QuotaUpgradeModalProps {
  open: boolean;
  onClose: () => void;
}

export const QuotaUpgradeModal = ({
  open,
  onClose,
}: QuotaUpgradeModalProps) => {
  const t = useTranslate();
  const { getQuota } = useQuota();
  const { trackEvent } = useAnalytics();
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);

  const quota = getQuota(QuotaFeatures.ProjectPublication);
  const count = quota?.quota_limit ?? 0;

  const handleUpgrade = () => {
    onClose();
    setIsPricingModalOpen(true);
  };

  useEffect(() => {
    if (open) {
      trackEvent(AnalyticsEvents.QuotaReachedView, {
        quota_feature: QuotaFeatures.ProjectPublication,
        quota_limit: count,
      });
    }
  }, [open, count, trackEvent]);

  return (
    <>
      <UpgradePromptModal
        open={open}
        onClose={onClose}
        onUpgrade={handleUpgrade}
        title={t("quota.projectQuotaReached")}
        description={t("quota.projectQuotaReachedDescription", { count })}
        upgradeLabel={t("buttons.upgradeToPro")}
        dismissLabel={t("quota.maybeLater")}
      />
      <PricingModal
        open={isPricingModalOpen}
        onClose={() => setIsPricingModalOpen(false)}
      />
    </>
  );
};
